export const selectLeaveEntryData = (state) =>
  state.leaveEntry.leaveEntryData;

export const selectLeaveEntryLoading = (state) =>
  state.leaveEntry.loading;

export const selectSelectedLeaveEntry = (state) =>
    state.leaveEntry.selectedLeaveEntry;

export const selectDeleteMessage = (state) =>
  state.leaveEntry.deleteMessage;

export const seletctLeaveRequestMeta = (state) => 
  state.leaveEntry.meta;